import type { Schema } from '../../amplify/data/resource'
import { generateClient } from 'aws-amplify/data'

interface Material {
    id: string,
    nome: string
}

const client = generateClient<Schema>()

const transformMaterialData = (data: any): Material => {
    return {
        id: data?.id ?? '',
        nome: data?.nome ?? ''
    }
}


const getMateriais = async (): Promise<any[]> => {
    try {
        const { data, errors } = await client.models.tbLabquimicoMateriais.list();

        if (errors) {
            throw new Error(`Failed to get Materiais: ${errors.map(e => e.message).join(', ')}`)
        }

        return data;
    } catch (error) {
        console.error('Erro ao buscar materiais: ', error);
        throw new Error('Failed to get materiais')
    }
}


const createMaterial = async (material: any) => {
    await client.models.tbLabquimicoMateriais.create(material)
}

const updateMaterial = async (material: Material): Promise<Material> => {
    try {
        const materialAtualizado = {
            ...material
        }

        const { data, errors } = await client.models.tbLabquimicoMateriais.update(materialAtualizado)

        if (errors) {
            throw new Error(`Failed to update Material: ${errors.map(e => e.message)}`)
        }

        const updatedMaterial = transformMaterialData(data)

        return updatedMaterial
    } catch (error) {
        console.error('Erro ao atualizar material: ', error)
        throw new Error('Failed to update material')
    }
}


const deleteMaterial = async (id: string): Promise<void> => {
    try {
      const { errors } = await client.models.tbLabquimicoMateriais.delete({ id });
  
      if (errors) {
        throw new Error(`Failed to delete Material: ${errors.map(e => e.message).join(', ')}`);
      }
  
      //console.log(`Material com ID: ${id} foi deletado com sucesso.`);
    } catch (error) {
      console.error('Erro ao deletar material:', error);
      throw new Error('Failed to delete material');
    }
  };


export { getMateriais, createMaterial, updateMaterial, deleteMaterial }
export type { Material }